export const bestResortsClass = [
  'mt-10',
  '[&_a]:no-underline',
  'md:max-lg:px-4',
].join(' ');

export const bestResortsTitleClass = 'mb-3 font-heading text-xl text-secondary md:text-2xl';

export const bestResortsDescriptionClass = 'mb-6 text-sm leading-relaxed text-foreground/85';
